import { apiClient } from '@mote/api'
import { getTZOffset } from '@mote/helpers'
import { canAccessWebLocalStorage } from '@mote/helpers/assertion'
import { WEB_STORAGE_PREFIX_KEYS } from '@mote/helpers/constants'
import { getAuthAttribute } from '@mote/helpers/identity'

export class StorageDataMigrator {
  CURRENT_VERSION = '2'
  STORAGE_VERSION_KEY = 'mote-storage-version'
  GOALS_KEY = `${WEB_STORAGE_PREFIX_KEYS}goals`

  get #storageVersion(): string {
    return window.localStorage.getItem(this.STORAGE_VERSION_KEY) || ''
  }

  set #storageVersion(version: string) {
    window.localStorage.setItem(this.STORAGE_VERSION_KEY, version)
  }

  #migrateLegacyUsers() {
    const userExists = getAuthAttribute('accessToken')
    const existingGoals = getAuthAttribute('goals')

    if (!userExists || existingGoals) return

    const fallbackGoals = {
      userOnboarding: 'skip_for_now',
      productOnboarding: 'required',
      makeFirstMote: 'required'
    }
    window.localStorage.setItem(this.GOALS_KEY, JSON.stringify(fallbackGoals))

    return apiClient
      .extend({
        timeout: 4000,
        retry: {
          limit: 3,
          methods: ['post']
        }
      })
      .post('v1/c/account', {
        json: { TZOffset: getTZOffset() }
      })
      .json()
      .then(() => {
        window.location.reload()
      })
      .catch(() => {
        window.location.href = '/login?force=1'
      })
  }

  async checkAndUpdateStorageVersion() {
    if (!canAccessWebLocalStorage()) return

    if (this.#storageVersion === this.CURRENT_VERSION) return
    console.log('Storage version changed - updating')

    this.#storageVersion = this.CURRENT_VERSION
    return this.#migrateLegacyUsers()
  }
}
